import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LosAngelesPin } from "../../../app-constants";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "Is there a high demand for software development in Los Angeles?",
    answer: `<p>Yes, there is a high demand for software development in Los Angeles. The city's vibrant tech ecosystem, home to startups, established companies, and a diverse range of industries, fuels the need for custom software solutions.
    With a growing reliance on technology, businesses and organizations in Los Angeles continually seek software developers to create innovative apps, websites, and systems that meet their specific needs.</p>`,
  },
  {
    question: "How much does software development cost in Los Angeles?",
    answer: `<p>The cost of software development depends on the complexity of the software, including factors such as the scope of features, development time, and the level of customization required. For accurate pricing, you can consult with our experts and get the estimated cost of your project.</p>`,
  },
  {
    question: "What is custom software development?",
    answer: `<p>Custom software development refers to the process of designing, creating, and maintaining software apps customized to specific business needs and requirements.
    It involves building software solutions from the ground up or customizing existing software to fit unique business processes.</p>`,
  },
  {
    question: "What does a software development company in Los Angeles do?",
    answer: `<p>Software development companies create, design, build, and manage apps, frameworks, or other software components for businesses or consumers.</p>`,
  },
  {
    question: "What is a software services company?",
    answer: `<p>A software services company offers a range of services related to software development, implementation, and support. These services may involve bespoke development, testing, design, and technical consultancy to assist clients in meeting their business objectives effectively.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{LosAngelesPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
